import {
  VibratingScreenFeederAnimatic,
  VibratingScreenFeederAnimaticProps,
} from '@crossnokaye/ux-animatics';

import {
  ANIMATIC_METRIC_1_LABEL_EXACT,
  ANIMATIC_PRIMARY_LABEL_EXACT,
} from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticVibratingScreenFeeder = ({
  config,
  labels,
  state,
  className,
}: AnimaticConfigProps) => {
  const vibratingScreenFeederConfig = config.specificAnimaticConfig?.vibratingScreenFeeder;
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL_EXACT);
  const metric1Label = getLabel(labels, ANIMATIC_METRIC_1_LABEL_EXACT);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <VibratingScreenFeederAnimatic
        incline={vibratingScreenFeederConfig?.incline ?? undefined}
        metric1Label={metric1Label?.text}
        motion={vibratingScreenFeederConfig?.motion ?? undefined}
        primaryLabel={primaryLabel?.text}
        screens={
          vibratingScreenFeederConfig?.screens as
            | VibratingScreenFeederAnimaticProps['screens']
            | undefined
        }
        state={state}
      />
    </ScaledAnimatic>
  );
};
